import { render, staticRenderFns } from "./HookInfo.vue?vue&type=template&id=56cc1452&scoped=true&"
import script from "./HookInfo.vue?vue&type=script&lang=js&"
export * from "./HookInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cc1452",
  null
  
)

export default component.exports